import React from 'react';
import { connect } from 'react-redux';
//import Profile from './components/Profile';

function ProfileContainer(props) {
    return (
        props.loggedIn
            ? <div>Hola {props.nombre}</div>
            : <div>Por favor inicia sesión.</div>
    )
}

const mapStateToProps = function (state) {
    return {
        //profile: state.user.profile,
        loggedIn: state.auth.loggedIn,
        nombre: state.auth.nombre,
    }
}

export default connect(mapStateToProps)(ProfileContainer);


/*
props.loggedIn
            ? <Profile profile={props.profile} />
            : <div>Please login to view profile.</div>
*/